import store from "../store/index";
const {getMortgagePurpose: resolveMortgagePurpose} = require("@/utils/mortgagePurpose");

export default {
  methods: {
    getMortgagePurpose () {
      const amounts = store.getters["mortgageDetailState/getAmounts"];
      const mortgage = store.getters["mortgageDetailState/getMortgage"];
      const properties = store.getters["mortgageDetailState/getProperties"];
      return resolveMortgagePurpose(amounts, mortgage?.ciel_prva_analyza, {
        forceAcquisition: (properties?.financedPropertiesIds || []).length > 0,
      });
    },
    getMortgageAmount() {
      const amounts = store.getters["mortgageDetailState/getAmounts"];
      let totalAmount = 0;
      for (const amount of Object.values(amounts)) {
        totalAmount += amount;
      }
      return totalAmount;
    }
  }
}
